import { BoltPageHeader } from './src/page-header';

const header = document.querySelector('header.c-bolt-page-header');
const headerComponent = new BoltPageHeader(header);
